import gql from 'graphql-tag'

export const RefreshToken = gql`
    mutation refreshToken($token: String!, $KeepLogged: KeepLoggedRefreshToken) {
        refreshToken(token: $token, KeepLogged: $KeepLogged) {
            access_token
            refresh_token
        }
    }
`
